(function($) {

	var $tables = $('.s-wysiwyg-content table');

	if ($tables.length) {

		$tables.each(function() {

			var $head = $(this).find('thead th');

			if ($head.length) {

				$tables.find('td').each(function() {

					var $column = $(this);

					var order = $column.index();

					$column.attr('data-th', $head.eq(order).text());

				});

			}

		});

	}

})(jQuery);
